export default {
  isLoading: false,
  error: null,
  invites: [],
}
